import { ActionType, getType } from 'typesafe-actions';

import { apiActions } from '../api/api.actions';
import { jobsActions } from './jobs.actions';
import { JobsState } from './jobs.types';
import { Job, JobState } from '../job/job.types';

export const INITIAL_JOBS_STATE: JobsState = [];

export function jobs(
  state: JobsState = INITIAL_JOBS_STATE,
  action: ActionType<typeof apiActions | typeof jobsActions>
): JobsState {
  switch (action.type) {
    case getType(jobsActions.setInitialJobs):
      return INITIAL_JOBS_STATE;
    case getType(apiActions.getOptimizationJobLimit.success):
    case getType(apiActions.aggregatedJobs.success):
      return action.payload;
    case getType(apiActions.aggregatedJobsById.success): {
      const { jobIds, jobs: fetchedJobs } = action.payload;
      const requestedIds = new Set(jobIds);
      // The endpoint may answer with the whole page, so only the jobs that were explicitly
      // asked for are treated as loaded outside the list; the rest are already in state.
      const fetched = (fetchedJobs || [])
        .filter((job: Job) => requestedIds.has(job.job_id))
        .map((job: Job) => ({ ...job, loadedOutOfList: true }));
      const fetchedIds = new Set(fetched.map((job: Job) => job.job_id));

      return state.filter((job: Job) => !fetchedIds.has(job.job_id)).concat(fetched);
    }
    case getType(apiActions.saveNewEditedPog.success):
    case getType(apiActions.updateEditedPog.success):
    case getType(apiActions.flipPog.success):
      return [action.payload.job].concat(state.filter((job: JobState) => job.job_id !== action.payload.job.job_id));
    case getType(apiActions.deletePogJob.success):
    case getType(apiActions.removePog.success):
      return [...state].filter((job: JobState) => job.job_id !== action.payload.job_id);
    case getType(apiActions.changePrivateAndSharedPogNames.success):
      return state.map((job: Job) => job.job_id === action.payload.job_id ? {
        ...job,
        pog_name: action.payload.private_pog_name,
        shared_pog_name: action.payload.shared_pog_name,
      } : job);
  }

  return state;
}
